import { useLocationService } from './internal/LocationServiceContext';
import { jsx as _jsx } from "react/jsx-runtime";
export function withCollapseAPI(CardFormatter) {
  const formatter = function CollapsibleFormatterWithAPI(props) {
    const {
      updateIsCardCollapsed
    } = useLocationService();
    return /*#__PURE__*/_jsx(CardFormatter, Object.assign({}, props, {
      onCollapseCard: updateIsCardCollapsed
    }));
  };
  // @ts-expect-error - iframeLookupKey is not defined on the CardFormatter component
  formatter.iframeLookupKey = CardFormatter.iframeLookupKey;
  return formatter;
}